import { useState } from "react";
import { AdvancedMarker } from "@vis.gl/react-google-maps";

//components
import SearchMapMark from "@/components/SearchMapMark";

// interfaces
import { IAdvancedMarkerComponent } from "../ISearchMap";

const AdvancedMarkerComponent = ({ location, activeLocationId, ...props }: IAdvancedMarkerComponent) => {
  const [isPopoverHovered, setIsPopoverHovered] = useState(false);

  return (
    <AdvancedMarker
      zIndex={isPopoverHovered ? 1000 : 1}
      {...props}
    >
      <SearchMapMark
        activeLocationId={activeLocationId as string}
        location={location}
        setIsHovered={setIsPopoverHovered}
      />
    </AdvancedMarker>
  )
}

export default AdvancedMarkerComponent;
